// extracted by mini-css-extract-plugin
export default {"loading__container":"Loading_loading__container__KYSaw","img":"Loading_img__UCUq1"};